/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */


const WyVaOptimizationUtils = {
  tablesMap: {
    'conversations': {
      // Hide 3 fields below base on OC-340 request
      // 'numOfSessions': 'Sessions',
      // 'nonActiveSessions': 'Null sessions',
      // 'sessionsWithNoLabel': 'Failed sessions',
      'numOfConversations': 'VA Conversations',
      'numberOfCustomerMessages': 'Customer messages'
    },
    //contained table mapping is matched with backend data. OC-952 review all mapping.
    'contained': {
      'conversationsContained': 'VA Conversations Contained',
      'containedResolved': 'Resolved',
      'containedTrueResolved': 'True Resolved',
      'containedWithBotRequestedFeedback': 'Contained conversations with feedback requested from the virtual agent',
      //'red label':'Contained conversations that received customer feedback',
      'containedWithPositiveFeedback': 'Received positive feedback',
      'containedWithNegativeFeedback': 'Received negative feedback'
    },
    //handedOff table mapping is matched with backend data. OC-952 review all mapping.
    'handedOff': {
      'conversationsHandedOffAkaHandoffs': 'Conversations handed off',
      'customerRequestedHandoff': 'Customer requested handoff',
      'automaticHandoffIntentBasedRouting': 'Automatic handoff after intent-based trigger',
      // Hide "automaticHandoffDueToDontUnderstand" base on OC-388 request
      // 'automaticHandoffDueToDontUnderstand': 'Automatic handoff due to not understood'
      // red label': Conversations automatically handed off
      // a. Automatic Handoff Intent Based Routing = Automatic handoff after intent-based routing trigger
      // b. Automatic Handoff Due To Dont Understand = Automatic handoff after bot failure message
    },
    //understanding table mapping is matched with backend data. OC-952 review all mapping.
    // 'understanding': {
    //   // 'conversationsWithMessagesNotUnderstood': 'Conversations with messages not understood',
    //   //'red label': 'Conversations with all messages understood',
    //   'numberOfCustomerMessages': 'Customer messages',
    //   // Hide "outOfDomain" base on OC-388 request
    //   // 'outOfDomain': 'Customer messages out-of-domain',
    //   'customerMessagesUnderstood': 'Customer messages understood',
    //   'customerMessagesNotUnderstoodFreeFormOnly': 'Customer messages not understood'
    // },
    //goals table mapping is matched with backend data. OC-952 review all mapping.
    // 'goals': {
    //   'conversationsWithAtLeastOneEndResponse': 'Conversations with at least one end response',
    //   //a. Contained with end-point = Conversation likely resolved
    // },
    'feedback': {
      'conversationsWithBotRequestedFeedback': 'Conversations with feedback request from virtual agent',
      'conversationsThatReceivedPositiveFeedback': 'Conversations that received positive feedback',
      'conversationsThatReceivedNegativeFeedback': 'Conversations that received negative feedback',
      //'red lebel': Conversations that received customer feedback
      //a. Conversations That Received Positive Feedback = Conversations that received positive feedback
      //b. Conversations That Received Negative Feedback = Conversations that received negative feedback
    },
    'issues': {
      // 'sessionsWithFeedbackMismatches': 'Conversations with customer messages mislabelled as feedback',
      // 'conversationsWithBotRepetition': 'Conversations with virtual agent repetition',
      // 'conversationsWithCustomerShortResponseTime': 'Conversations with abnormally short customer response time',
      'conversationsWithVARepetition': 'Conversations with virtual agent repetition',
      'conversationsWithMessagesNotUnderstood': 'Conversations with customer message not understood'
    },
    //customerBehaviour table mapping is matched with backend data. OC-952 review all mapping.
    // hide customerBehaviour table totally base on OC-388
    // 'customerBehaviour': {
    //   'freeformMessages': 'Customer messages sent as button clicks',
    //   'buttonClicks': 'Customer messages sent as text messages',
    //   'buttonsClicksAddressed': 'Buttons clicks handled'
    // },
    //corpus table mapping is matched with backend data. OC-952 review all mapping.
    'corpus': {
      // 'numberOfBotResponses': 'Bot responses',
      'numberOfIntents': 'Intents',
      'numberOfUtterances': 'Number of Utterances',
      'numberOfWildcardUtterances': 'Utterances with wildcards'
    },
    'response':{
      'conversationsHasEndResponse': 'Conversations with at least one end response'
    },
    'nluTraining': {
      'nluTrainingMessagesUnderstood': 'Customer messages understood',
      'falsePositives': 'False-positive rate',
      'messagesWithDYM': 'Customer messages with DYM',
      'nluTrainingMessagesNotUnderstood': 'Customer messages not understood',
      'topicCandidates': 'Candidates for new intents',
      'trainingCandidates': 'Candidates for existing intents',
      'outOfDomain': 'Out of domain',
      'underTrainedIntents': 'Undertrained intents',
      'duplicateIntents': 'Similar intents',
      'duplicateUtterances': 'Similar utterances',
      'numInconsistentIntents': 'Intents with low quality utterances'
      // Hide "numberOfUtterancesWithoutWildcards" base on OC-388 request
      // 'numberOfUtterancesWithoutWildcards': 'Utterances Without Wildcards',
    }
  },
  pieChartOverviewMap: {
    // Overview
    understanding: 'Natural Language Understanding',
    containment: 'VA Conversations Contained',
    negativeFeedbackScore: 'Negative Feedback Score'
  },
  pieChartResponsePerformanceMap: {
    //Response Performance
    negativeFeedbackRate: 'Negative feedback rate',
    handoffRate: 'Handoff rate',
    botRepetitionRate: 'Bot repetition rate'
  },
  pieChartNluIntentPerformanceMap: {
    //NLU Intent Performance
    nlu: 'NLU',
    falsePositives: 'False Positives',
    messagesNotUnderstood: 'Messages Not Understood',
    lowQualityIntents: 'Low Quality Intents'
  }
};

export default WyVaOptimizationUtils;